module.exports = {"610721001":"汉山街道","610721101":"圣水镇","610721102":"大河坎镇","610721103":"协税镇","610721104":"梁山镇","610721105":"阳春镇","610721106":"高台镇","610721107":"新集镇","610721108":"濂水镇","610721109":"黄官镇","610721110":"青树镇","610721111":"红庙镇","610721112":"牟家坝镇","610721113":"法镇","610721114":"湘水镇","610721115":"小南海镇","610721116":"碑坝镇","610721117":"黎坪镇","610721118":"福成镇","610721119":"两河镇","610721120":"胡家营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610721.json
// module id = 2639
// module chunks = 0